import { AssessmentStatus } from "./api-data-types";

import { SERVER_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import {
  AllAssessmentTableRow,
  SectionScoreTableRow,
  StudentAssessmentScoreTableRow,
  StudentOutcomeScoreTableData,
} from "api/api-types-assessment";
import { withApiErrorReporting } from "utils/api-errors";
import { CSVData } from "utils/file";

export async function serverGetSectionScoreTable(
  sectionId: string,
): Promise<SectionScoreTableRow[]> {
  return withApiErrorReporting("serverGetSectionScoreTable", async () => {
    const response = await serverApi.get<SectionScoreTableRow[]>(
      `${SERVER_API_PATH}/assessment/section_scores/table/`,
      { params: { section_id: sectionId } },
    );
    return response.data;
  });
}

export async function serverGetSectionScoreReport(params: {
  term_id?: string;
  course_id?: string;
  section_id?: string;
}): Promise<CSVData> {
  return withApiErrorReporting("serverGetSectionScoreReport", async () => {
    const response = await serverApi.get<CSVData>(
      `${SERVER_API_PATH}/assessment/section_scores/report/`,
      { params },
    );
    return response.data;
  });
}

export async function serverGetAllAssessmentTable(
  sectionId: string,
): Promise<AllAssessmentTableRow[]> {
  return withApiErrorReporting("serverGetAllAssessmentTable", async () => {
    const response = await serverApi.get<AllAssessmentTableRow[]>(
      `${SERVER_API_PATH}/assessment/page_assessments/table/`,
      { params: { section_id: sectionId } },
    );
    return response.data;
  });
}

export async function serverGetStudentAssessmentScoreTable(
  sectionId: string,
  userId?: string | null,
): Promise<StudentAssessmentScoreTableRow[]> {
  return withApiErrorReporting("serverGetStudentAssessmentScoreTable", async () => {
    const params: { section_id: string; user_id?: string } = { section_id: sectionId };
    if (userId) {
      params.user_id = userId;
    }
    const response = await serverApi.get<StudentAssessmentScoreTableRow[]>(
      `${SERVER_API_PATH}/assessment/student_assessment_scores/table/`,
      { params },
    );
    return response.data;
  });
}

export async function serverGetStudentOutcomeScoreTable(
  sectionId: string,
  userId?: string | null,
): Promise<StudentOutcomeScoreTableData> {
  return withApiErrorReporting("serverGetStudentOutcomeScoreTable", async () => {
    const params: { section_id: string; user_id?: string } = { section_id: sectionId };
    if (userId) {
      params.user_id = userId;
    }
    const response = await serverApi.get<StudentOutcomeScoreTableData>(
      `${SERVER_API_PATH}/assessment/student_outcome_scores/table/`,
      { params },
    );
    return response.data;
  });
}

export async function serverGetAllAssessmentReport(params: {
  term_id?: string;
  course_id?: string;
  section_id?: string;
  report_filter?: AssessmentStatus;
}): Promise<CSVData> {
  return withApiErrorReporting("serverGetAllAssessmentReport", async () => {
    const response = await serverApi.get<CSVData>(
      `${SERVER_API_PATH}/assessment/page_assessments/report/`,
      { params },
    );
    return response.data;
  });
}
